import React from "react";
import { useSelector } from "react-redux";
import FallbackComponent from "./fallback.page";

export default function FallbackContainer() {
  const lang = useSelector(state => state.constant.languages);
  return <FallbackComponent lang={lang}/>;
}
